export default [
  {
    label: '고객센터',
    value: '/about/vision',
    children: [
      {
        label: '비전',
        value: '/join',
        children: [
          {
            label: '회원가입',
            value: '/join',
          },
          {
            label: '핵심가치',
            value: '/ksl/login',
          },
        ],
      },
      {
        label: 'CEO 인사말',
        value: '/about/ceo',
      },
      {
        label: '사업내용',
        value: '/about/distribution',
        children: [
          {
            label: '유통 사업',
            value: '/about/distribution',
          },
          {
            label: '해외 사업',
            value: '/about/global',
          },
          {
            label: '면세점 사업',
            value: '/about/dutyfree',
          },
        ],
      },
    ],
  },
  {
    label: '마이페이지',
    value: '/my/progress',
    children: [
      {
        label: '심사신청현황목록',
        value: '/my/progress',
      },
      {
        label: '제품개발',
        value: '/rnd/product',
      },
    ],
  },
  {
    label: '홍보센터',
    value: '/pr/news',
    children: [
      {
        label: '회사소식',
        value: '/pr/news',
      },
      {
        label: '보도자료',
        value: '/pr/press',
      },
    ],
  },
  {
    label: '고객센터',
    value: '/cs/qna',
    children: [
      {
        label: '1:1문의',
        value: '/cs/qna',
      },
      {
        label: 'FAQ',
        value: '/cs/faq',
      },
      {
        label: '오시는길',
        value: '/cs/location',
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/views/front/struct/index.js